module.exports = __webpack_public_path__ + "img/hellerman-logo.29b9977c.png";